import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emoji',
})
export class EmojiPipe implements PipeTransform {
  // Regular expression to find Unicode code points (U+XXXX format)
  private unicodeRegex = /U\+([0-9A-F]{4,})/g;
  
  // Regular expression to find HTML hex code emojis (&#xXXXX; and &#XXXXX; formats)
  private htmlHexRegex = /&#x?([0-9a-fA-F]{1,}|[0-9]{1,});/g;

  transform(value: string): string {
    if (!value) return '';
    
    // Replace all Unicode code points with actual emoji
    let result = value.replace(this.unicodeRegex, (match, codePoint) => {
      try {
        return String.fromCodePoint(parseInt(codePoint, 16));
      } catch (e) {
        return match; // Return the original text if conversion fails
      }
    });
    
    // Replace all HTML hex code emojis with actual emoji
    result = result.replace(this.htmlHexRegex, (match, codePoint) => {
      try {
        // Check if it's a hex (&#x) or decimal (&#) format
        if (match.startsWith('&#x')) {
          return String.fromCodePoint(parseInt(codePoint, 16));
        } else {
          return String.fromCodePoint(parseInt(codePoint, 10));
        }
      } catch (e) {
        return match; // Return the original text if conversion fails
      }
    });
    
    return result;
  }
}
